import { mapRef, ref } from "@knyt/artisan";
import { track, } from "@knyt/tasker";
import { DeferredContentContext } from "./DeferredContentContext.js";
import { ImmutableRegistry } from "./ImmutableRegistry.js";
/**
 * A controller that manages deferred content rendering based on the state of associated promises.
 *
 * @internal scope: package
 */
export class DeferredContentController {
    #host;
    #provider;
    #promises$ = ref(new ImmutableRegistry());
    isLoading$;
    constructor(host) {
        this.#host = host;
        this.#provider = DeferredContentContext.createProvider(host);
        this.isLoading$ = mapRef(this.#promises$, (promises) => promises.hasAny);
        track(this.#host, this.isLoading$);
        this.#provider.set(this);
        host.addController(this);
    }
    registerPromise(promise) {
        if (this.#promises$.value.has(promise)) {
            return promise;
        }
        this.#promises$.set(this.#promises$.value.with(promise));
        promise.finally(() => {
            this.unregisterPromise(promise);
        });
        return promise;
    }
    unregisterPromise(promise) {
        if (!this.#promises$.value.has(promise)) {
            return;
        }
        this.#promises$.set(this.#promises$.value.without(promise));
    }
    hostConnected() { }
}
